module.exports = __webpack_public_path__ + "static/img/wakabayashi_name.84a72d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/players/wakabayashi_name.png
// module id = z9xm
// module chunks = 0